import { render, staticRenderFns } from "./ClientsAdmin.vue?vue&type=template&id=b1a6d03e&"
import script from "./ClientsAdmin.vue?vue&type=script&lang=js&"
export * from "./ClientsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1a6d03e')) {
      api.createRecord('b1a6d03e', component.options)
    } else {
      api.reload('b1a6d03e', component.options)
    }
    module.hot.accept("./ClientsAdmin.vue?vue&type=template&id=b1a6d03e&", function () {
      api.rerender('b1a6d03e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientsAdmin.vue"
export default component.exports